module.exports = __webpack_public_path__ + "static/media/passportSample.bfdfe82d.jpg";